import * as actionTypes from './types';

const inituelState = {
    loading: false,
    error: false,
    
    cities: null
};
const cityReducer = (state = { ...inituelState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.REQUST_CITY:
            return {
                ...state,
                cities:[],
                loading: true
            };
        case actionTypes.FAILED_CITY:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case actionTypes.SUCCESS_CITY:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false
            };

      
        default:
            return {
                ...state
            };
    }
};

export default cityReducer;
